import React from "react"
import "components/style.scss"

const PhoneArea = ({ children }) => {
  return (
    <div className={"d-flex flex-column align-items-center"}>
      <div className={"phone-area"}>
        {children}
      </div>
      <div className={"font-size-13 text-center mt-1"}>
        Please note that this preview is not an exact representation.
      </div>
    </div>
  )
}

export default PhoneArea
